import { render, staticRenderFns } from "./GerenciarCanaisDeVenda.vue?vue&type=template&id=20758a4c&scoped=true"
import script from "./GerenciarCanaisDeVenda.vue?vue&type=script&lang=js"
export * from "./GerenciarCanaisDeVenda.vue?vue&type=script&lang=js"
import style0 from "./GerenciarCanaisDeVenda.vue?vue&type=style&index=0&id=20758a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20758a4c",
  null
  
)

export default component.exports